<template>
    <rkm-modal
        ref="modal"
        title="Justificativa do cancelamento"
    >
        <rkm-form
            ref="Form"
            show-legend
        >
            <rkm-form-textarea
                :validations="validations.justificativa"
                label="Justificativa"
                v-model="model.justificativa"
            />
        </rkm-form>

        <template v-slot:footer="{ cancel }">
            <rkm-button
                @click="cancel"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                @click="cancelSolicitacao"
                color="primary"
                type="submit"
            >
                Salvar
            </rkm-button>
        </template>

    </rkm-modal>
</template>
<script>

// Mixin.
import { repository } from '@/mixins'

export default {
     computed: {
        validations() {
            return {
                justificativa: {
                    max: 500,
                    required: true,
                }
            }
        }
    },
    created() {

        this.repositories = {
            solicitacao: this.getConectaSusRepository('regulacao.solicitacao'),
        }
    },
    data: () => ({
        model: {
            id: null,
            justificativa: null,
        },
    }),
    methods: {

        open(item) {

            this.model.id = item
            this.model.justificativa = null
            this.$refs.modal.show()
        },
        cancelSolicitacao() {

            this.$refs.Form.validate()
                .then( validate => {

                    if (!validate) return

                    this.repositories.solicitacao.cancel(
                        this.model.id,
                        { justificativa: this.model.justificativa }
                    )
                    .then(() => {
                        this.showSaveNotification('Solicitação cancelada com sucesso!')
                        this.$emit('refresh')
                        this.$refs.modal.hide()
                    })
                    .catch(this.handleError)

                })


        },
    },
    mixins: [ repository ],
}
</script>